const isRecord = (value) => typeof value === 'object' && value !== null && !Array.isArray(value);
const isNumber = (value) => typeof value === 'number' && Number.isFinite(value);
const isInteger = (value) => isNumber(value) && Number.isInteger(value);
const isId = (value) => isInteger(value) && value > 0;
const isNonnegativeInteger = (value) => isInteger(value) && value >= 0;
const isNullableString = (value) => value === null || typeof value === 'string';
const isOptionalString = (value) => value === undefined || isNullableString(value);
const isStringArray = (value) => Array.isArray(value) && value.every(item => typeof item === 'string');
export const isLocation = (value) => isRecord(value) &&
    isId(value.id) &&
    typeof value.name === 'string' &&
    isOptionalString(value.logo) &&
    isOptionalString(value.address) &&
    isOptionalString(value.workingHours) &&
    isOptionalString(value.extraInfo) &&
    isOptionalString(value.description);
export const isSnapshot = (value) => {
    if (!isRecord(value) || !isRecord(value.product) || !isRecord(value.locations) || !isRecord(value.selection)) {
        return false;
    }
    const { product, locations, selection } = value;
    return (typeof value.token === 'string' &&
        value.token.length > 0 &&
        isNonnegativeInteger(value.revision) &&
        typeof value.quote === 'string' &&
        value.quote.length > 0 &&
        (value.stage === 'authentication' || value.stage === 'account' || value.stage === 'delivery') &&
        typeof product.name === 'string' &&
        typeof product.variantCode === 'string' &&
        isOptionalString(product.color) &&
        product.quantity === 1 &&
        isNumber(product.unitPrice) &&
        isNumber(product.originalUnitPrice) &&
        isNumber(product.discount) &&
        Array.isArray(locations.store) &&
        locations.store.every(isLocation) &&
        Array.isArray(locations.reseller) &&
        locations.reseller.every(isLocation) &&
        (selection.method === 'store' || selection.method === 'reseller' || selection.method === null) &&
        (selection.id === null || isId(selection.id)) &&
        isNullableString(value.code) &&
        isStringArray(value.codeErrors) &&
        (value.codeAction === undefined ||
            value.codeAction === null ||
            (isRecord(value.codeAction) &&
                typeof value.codeAction.url === 'string' &&
                value.codeAction.url.startsWith('/') &&
                !value.codeAction.url.startsWith('//') &&
                typeof value.codeAction.label === 'string')) &&
        isNullableString(value.selectionError) &&
        isOptionalString(value.availabilityError) &&
        (value.priceChanged === undefined || typeof value.priceChanged === 'boolean') &&
        isNumber(value.total) &&
        isNumber(value.deliveryPrice) &&
        isNonnegativeInteger(value.cartQuantity));
};
export const isSuccess = (value) => {
    if (!isRecord(value))
        return false;
    return (value.stage === 'success' &&
        isId(value.orderId) &&
        typeof value.orderNumber === 'string' &&
        isNullableString(value.orderDate) &&
        isRecord(value.product) &&
        typeof value.product.name === 'string' &&
        typeof value.product.variantCode === 'string' &&
        isNullableString(value.product.color) &&
        isRecord(value.analytics) &&
        typeof value.analytics.name === 'string' &&
        typeof value.analytics.color === 'string' &&
        typeof value.analytics.category === 'string' &&
        typeof value.analytics.pickupName === 'string' &&
        isOptionalString(value.analytics.productVersion) &&
        (value.analytics.isHeatingSet === undefined || typeof value.analytics.isHeatingSet === 'boolean') &&
        typeof value.email === 'string' &&
        isNumber(value.total) &&
        isNumber(value.deliveryPrice) &&
        isNumber(value.unitPrice) &&
        isNumber(value.originalUnitPrice) &&
        isNumber(value.discount) &&
        isNumber(value.tax) &&
        isNullableString(value.coupon) &&
        (value.shippingMethod === 'store' || value.shippingMethod === 'reseller') &&
        (value.pickup === null || isLocation(value.pickup)) &&
        (value.points === null || isInteger(value.points)) &&
        isNonnegativeInteger(value.cartQuantity));
};
export const isRedirect = (value) => isRecord(value) && typeof value.redirect === 'string' && value.redirect.length > 0;
export const isCloseResponse = (value) => isRecord(value) && typeof value.closed === 'boolean';
export const isCsrfResponse = (value) => isRecord(value) && typeof value.csrf === 'string' && value.csrf.length > 0;
export const errorDetails = (value) => {
    if (!isRecord(value))
        return { message: null, code: null };
    return {
        message: typeof value.error === 'string' ? value.error : null,
        code: typeof value.code === 'string' ? value.code : null,
    };
};
